import { render, staticRenderFns } from "./Mandatory.vue?vue&type=template&id=ed383f08&"
import script from "./Mandatory.vue?vue&type=script&lang=js&"
export * from "./Mandatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed383f08')) {
      api.createRecord('ed383f08', component.options)
    } else {
      api.reload('ed383f08', component.options)
    }
    module.hot.accept("./Mandatory.vue?vue&type=template&id=ed383f08&", function () {
      api.rerender('ed383f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CourseRequestForms/Mandatory.vue"
export default component.exports